<div class="container__application">
    <navbar [hidden]="!enableNav"></navbar>
    <div class="container__application__body">
        <main class="content__container">
            <router-outlet class="router"></router-outlet>
        </main>
        <footer *ngIf="enableFooter && (isLogged || isLoginPage)"></footer>
    </div>
</div>
